<template>
  <div v-if="show" class="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">
    <div class="bg-white p-8 rounded-lg shadow-md max-w-md relative">
      <button @click="$emit('close')"
        class="absolute top-2 right-2 text-gray-600 hover:text-gray-800 focus:outline-none">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="feather feather-x">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      <h2 class="text-xl font-semibold mb-4">{{ name }}</h2>
      <p v-for="(desc, index) in description" :key="index" class="text-gray-700 mb-2">{{ desc }}</p>
      <p class="text-gray-500 text-xs italic mb-4">{{ disclaimer }}</p>
       <p class="text-gray-700 font-bold mb-4">ID de esta sesión: <span class="font-mono">{{ chatSessionId }}</span></p>
       <button @click="showConfirmation"
                class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">Nueva Conversación</button>
        <div v-if="showConfirmationDialog" class="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div class="bg-white p-8 rounded-lg shadow-md max-w-md relative">
           <p>¿Desea iniciar una nueva conversación? Perderá el progreso actual, copie el código actual para consultarlo despues:</p>
             <div class="flex justify-center mt-4">
              <button @click="confirmNewSession" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mr-2">Si, iniciar nueva sesión</button>
           <button @click="cancelNewSession" class="bg-gray-400 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">Cancelar</button>
                </div>
           </div>
         </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
      name: { type: String, required: true },
    description: { type: Array, required: true },
    disclaimer: { type: String, required: true },
      chatSessionId: { type: String, required: true }
  },
    emits: ['close', 'newSession'],
    data(){
        return {
            showConfirmationDialog: false,
        }
    },
    methods: {
        showConfirmation(){
            this.showConfirmationDialog = true;
        },
       confirmNewSession(){
         this.$emit("newSession");
           this.showConfirmationDialog = false;
           this.$emit('close');
       },
        cancelNewSession(){
            this.showConfirmationDialog = false;
       }
    }
};
</script>